import styled from '@emotion/styled';
import { Tooltip } from 'antd';
import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { LocaleKeys } from '../../locale';
import { TooltipQuestionIcon } from '../icons/tooltip-question';
import {
  BasePopover,
  BasePopoverMenuItemLabel,
  BasePopoverMenuItemText,
  BasePopoverMenuList,
  BasePopoverWrapper,
  TBasePopoverProps,
} from './base-popover';

const IconWrapper = styled('div')`
  width: 18px;
  margin-top: 8px;

  svg {
    width: 18px;
    height: 18px;
  }
`;

type TVariantsProps = {
  onUploadWithLinkClick: () => void;
  onWithoutUploadClick: () => void;
};

const UploadVariants: FC<TVariantsProps> = ({
  onWithoutUploadClick,
  onUploadWithLinkClick,
}) => {
  const { t } = useTranslation([LocaleKeys.VIDEO]);
  return (
    <BasePopoverWrapper
      style={{
        minWidth: 260,
      }}
    >
      <BasePopoverMenuList>
        <BasePopoverMenuItemLabel htmlFor="add-video-file">
          {t('videos.download.computer')}
        </BasePopoverMenuItemLabel>
        <BasePopoverMenuItemLabel htmlFor="add-any-file">
          {t('videos.download.anyFile')}
        </BasePopoverMenuItemLabel>
        {/*<BasePopoverMenuItemText to={'/'} onClick={onUploadWithLinkClick}>
          {t('videos.download.url')}
        </BasePopoverMenuItemText>*/}
        <BasePopoverMenuItemText to={'/'} onClick={onWithoutUploadClick}>
          {t('videos.download.without')}
          <Tooltip
            title={t('videos.download.warningUploadVideo')}
            placement="bottomLeft"
          >
            <IconWrapper>
              <TooltipQuestionIcon />
            </IconWrapper>
          </Tooltip>
        </BasePopoverMenuItemText>
      </BasePopoverMenuList>
    </BasePopoverWrapper>
  );
};

type TProps = PropsWithChildren<TBasePopoverProps> & TVariantsProps;

export const UploadVideoVariantsPopover: FC<TProps> = ({
  children,
  onUploadWithLinkClick,
  onWithoutUploadClick,
  ...props
}) => {
  return (
    <BasePopover
      componentToShow={
        <UploadVariants
          onWithoutUploadClick={onWithoutUploadClick}
          onUploadWithLinkClick={onUploadWithLinkClick}
        />
      }
      {...props}
    >
      {children}
    </BasePopover>
  );
};
